import(/* webpackMode: "eager" */ "/codebuild/output/src36880211/src/apps/fanychance/src/components/layouts/PageHeader/PageHeader.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src36880211/src/apps/fanychance/src/features/auth/components/FanyForm/FanyForm.tsx");
